import { combineEpics } from "redux-observable";

import {
  grabarCuenta,
  listarCuenta,
  editarCuenta,
  listarCuentaUsuario,
  listarMaxPlacaExenta,
  enriquecerCuentasEpic,
  grabarLimitePlacaExenta,
  grabarLimiteMaxZonas,
  grabarLimiteMaxPerfilesAdministrador,
  grabarLimiteMaxPerfilesSupervisor,
  grabarLimiteMaxPerfilesAuxiliar,
  grabarLimiteMaxPerfilesMunicipio,
  grabarLimiteMaxPerfilesVisor,
  grabarLimiteMaxPerfilesPromotor
} from "conten/cuentas/CuentaEpic";

import {
  ingresoInicioSolicitud,
  ingresoCompletarSolicitud,
  salirSesion,
} from "conten/ingresoSistema/IngresoSistemaEpic";

import {
  listarDocumentos,
  listarPerfiles,
  guardarUsuario,
  listarUsuario,
} from "conten/usuarios/UsuarioEpic";

import { guardarZona, listarZona } from "conten/zonas/ZonaEpic";
import {
  guardarPromotorZona,
  listarPromotorZona,
} from "conten/promotorZonas/PromotorZonaEpic";

import {
  listarTiquete,
  listarTiquetePazYSalvo,
  actualizarTiquetePazYSalvo,
  grabarTiquete,
  grabarLimiteEndeudamientoPromotor,
  getLimiteEndeudamientoPromotor,
} from "conten/configuracion/ConfiguracionEpic";

import {
  solicitarListarRecaudoReporte,
  solicitarGuardarRecaudoReporte,
  solicitarListarPagoMunicipio,
  solicitarGuardarPagoMunicipio,
  solicitarListarFechaPago,
} from "conten/financiera/FinancieraEpic";

import {
  listarSupervisionPregunta,
  grabarSupervisionPregunta,
  borrarSupervisionPregunta,
} from "conten/supervision/SupervisionEpic";

import {
  hacerPagoExtemporaneoWEB,
  informeSupervision,
  informeSaldoPromotor,
  informeMensual,
  informeVehiculo,
  informeCartera,
  informeHistorico,
} from "conten/informes/InformesEpic";

import { listarPlacasEpic,guardarPlacaEpic,actualizarPlacaEpic } from "conten/mensualidades/Placas/PlacasEpic";

import { guardarPlanEpic,
   guardarPlanZonaEpic,
    listarPlanZonaEpic,
     listarPlanEpic 
  } from "conten/mensualidades/planes/PlanesEpic";
import { listarSuscripcionPlacaEpic } from "conten/mensualidades/SuscripcionPlaca/SuscripcionPlacaEpic";
import { guardarSuscripcionPlacaEpic } from "conten/mensualidades/SuscripcionPlaca/SuscripcionPlacaEpic";
import { listarZonaActivaEpic } from "conten/mensualidades/planes/PlanesEpic";
import { listarPlacasActivasEpic } from "conten/mensualidades/SuscripcionPlaca/SuscripcionPlacaEpic";
import { listarPlanesActivosEpic } from "conten/mensualidades/SuscripcionPlaca/SuscripcionPlacaEpic";

export const rootEpic = combineEpics(
  grabarCuenta,
  listarCuenta,
  editarCuenta,
  listarCuentaUsuario,
  listarMaxPlacaExenta,
  enriquecerCuentasEpic,
  grabarLimitePlacaExenta,
  grabarLimiteMaxZonas,
  grabarLimiteMaxPerfilesAdministrador,
  grabarLimiteMaxPerfilesSupervisor,
  grabarLimiteMaxPerfilesAuxiliar,
  grabarLimiteMaxPerfilesMunicipio,
  grabarLimiteMaxPerfilesVisor,
  grabarLimiteMaxPerfilesPromotor,

  ingresoInicioSolicitud,
  ingresoCompletarSolicitud,
  salirSesion,

  listarDocumentos,
  listarPerfiles,
  guardarUsuario,
  listarUsuario,

  guardarZona,
  listarZona,

  guardarPromotorZona,
  listarPromotorZona,

  listarTiquete,
  grabarTiquete,
  listarTiquetePazYSalvo,
  actualizarTiquetePazYSalvo,
  grabarLimiteEndeudamientoPromotor,
  getLimiteEndeudamientoPromotor,

  solicitarListarRecaudoReporte,
  solicitarGuardarRecaudoReporte,
  solicitarListarPagoMunicipio,
  solicitarGuardarPagoMunicipio,
  solicitarListarFechaPago,

  listarSupervisionPregunta,
  grabarSupervisionPregunta,
  borrarSupervisionPregunta,

  hacerPagoExtemporaneoWEB,
  informeSupervision,
  informeSaldoPromotor,
  informeMensual,
  informeVehiculo,
  informeCartera,
  informeHistorico,

  listarPlacasEpic,
  guardarPlacaEpic,
  actualizarPlacaEpic,

  listarPlanEpic,
  listarPlanZonaEpic,
  listarZonaActivaEpic,
  guardarPlanZonaEpic,
  guardarPlanEpic,

  listarSuscripcionPlacaEpic,
  guardarSuscripcionPlacaEpic,
  listarPlacasActivasEpic,
  listarPlanesActivosEpic
);
